import { render } from "./SpanServiceNoMobilePhone.vue?vue&type=template&id=0a97cb22"
import script from "./SpanServiceNoMobilePhone.vue?vue&type=script&lang=js"
export * from "./SpanServiceNoMobilePhone.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__